export const resolveDefinitionWithLabel = ({ definition, label }) => {
  if (!label || label === definition?.name) {
    return definition;
  }

  return { ...definition, name: label };
};
